import type { ReactNode } from 'react';

type Tone = 'primary' | 'accent' | 'neutral' | 'danger';

interface PillProps {
  children: ReactNode;
  tone?: Tone;
  leading?: ReactNode;
  className?: string;
}

const TONE: Record<Tone, string> = {
  primary:
    'bg-[color:var(--color-primary-dim)] text-primary border border-[color:var(--color-primary-mid)]',
  accent:
    'bg-[color:var(--color-accent-dim)] text-accent border border-accent/30',
  neutral:
    'bg-transparent text-on-surface-dim border border-[color:var(--color-border)]',
  danger:
    'bg-[color:var(--color-error-dim)] text-error border border-error/30',
};

export function Pill({ children, tone = 'neutral', leading, className = '' }: PillProps) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1 rounded-full px-2 py-[3px]',
        'font-body text-[10px] font-semibold uppercase tracking-[0.08em]',
        TONE[tone],
        className,
      ].join(' ')}
    >
      {leading}
      {children}
    </span>
  );
}
